export enum TestProcedureType {
  WLTP = 'WLTP',
  NEDC = 'NEDC'
}

export enum EmissionsType {
  CO2 = 'CO2',
  NOX = 'NOX'
}

export interface OneShopV2NewUnitValue {
  /**
   * The consumption or emission unit
   * example:
   * l/100km
   */
  unit: string;

  /**
   * The consumption or emission value
   * example:
   * 4.3
   */
  value: number;
}

export interface OneShopV2NewVehicleEmission {
  /**
  * The emissions measured under conditions of combined energy consumption.
  */
  combined: OneShopV2NewUnitValue;

  /**
  * enum
  * Indicates which type of gas the indicated emission refers to.
  */
  emissionsType: EmissionsType;

}

export interface OneShopV2NewVehicleConsumption {

  /**

    * The consumptions of the vehicle depending on fuel type.

    */

  combined: OneShopV2NewUnitValue;

}

export type EfficiencyClass = 'A_PLUS_PLUS_PLUS' | 'A_PLUS_PLUS' | 'A_PLUS' | 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

export declare class VehicleModelEconomics  {
  /**
  * enum
  * Indicates the test procedure applied to derive emission and consumption values of the vehicle. Note that the former NEDC (German: NEFZ) is being replaced by the more recent WLTP method.
  */
  testProcedureType: TestProcedureType;

  /**
  * The emissions of the vehicle.
  */
  emissions: OneShopV2NewVehicleEmission[];

  /**
  * The consumptions of the vehicle.
  */
  consumptions: OneShopV2NewVehicleConsumption[];

  /**
  * enum
  * Represents the efficiency class.
  * example:
  * A_PLUS
  */
  efficiencyClass: EfficiencyClass;
}
